import script from "./Tutorial.vue?vue&type=script&setup=true&lang=js"
export * from "./Tutorial.vue?vue&type=script&setup=true&lang=js"

import "./Tutorial.vue?vue&type=style&index=0&id=3ffa1fc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ffa1fc2"]])

export default __exports__